module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slideIn listSingle",
    attrs: {
      "id": "listPostWrapper"
    }
  }, [_c('div', {
    staticClass: "listPostsWrapper",
    class: {
      collapsed: _vm.hidePostList
    }
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('singlepostindex', {
      attrs: {
        "yearview": _vm.yearview,
        "collapseAll": _vm.collapseAll,
        "yearColor": _vm.yearColor,
        "index": _vm.indexGradyears,
        "workstudent": _vm.workstudents[index],
        "projectslength": _vm.projects.length,
        "id": project.id,
        "title": project.acf.shorttitle,
        "fulltitle": project.title.rendered
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-228797af!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Listposts.vue
// module id = 55
// module chunks = 1